module.exports = __webpack_public_path__ + "img/previewImg5.2643cb18.png";